import { render, staticRenderFns } from "./myshare.vue?vue&type=template&id=481bede7&scoped=true&"
import script from "./myshare.vue?vue&type=script&lang=js&"
export * from "./myshare.vue?vue&type=script&lang=js&"
import style0 from "./myshare.vue?vue&type=style&index=0&id=481bede7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481bede7",
  null
  
)

export default component.exports